<template>
  <aside class="sidebar">
    <div class="side-box shadow-box">
      <form enctype="multipart/form-data" id="profile-form">
        <div class="photo-profile">
          <div class="photo-in">
            <label for="profile-picture">
              <img :src="me.profile_image_url" :alt="me.name.formatted_name" :title="me.name.formatted_name">
            </label>
            <div class="wrap-file">
              <input type="file" name="profilePic" style="display:hidden" id="profile-picture" @change="fileChange($event)">
              <i class="fa fa-camera" aria-hidden="true"></i>
            </div>
          </div><!-- /photo-in -->
        </div><!-- /photo-profile -->
      </form>
      <h2>{{ me.name.formatted_name }}</h2>
      <p v-if="hasAccountId">Account #: <strong>{{ me.customer_id }}</strong></p>
      <p v-else><a href="#" class="my-account-country" @click="showSignupCountryModal">Complete Profile</a></p>
    </div><!-- /side-box -->

    <div class="fb-btn-group">
      <a v-if="!facebookDelegate" href="#" @click.prevent="connectSocialAccount('facebook')" target="_blank" class="btn btn-block btn-facebook">Connect Facebook</a>
      <a v-else href="#" @click.prevent="disconnectSocialAccount('facebook')" target="_blank" class="btn btn-block btn-facebook">Disconnect Facebook</a>
    </div>

    <div class="google-btn-group">
      <a v-if="!googleDelegate" href="#" @click.prevent="connectSocialAccount('google')" target="_blank" class="btn btn-block btn-google">Connect Google</a>
      <a v-else href="#" @click.prevent="disconnectSocialAccount('google')" target="_blank" class="btn btn-block btn-google">Disconnect Google</a>
    </div>

  </aside>
</template>

<script>
  export default {
    name: 'account-card',

    props: {
      client_id: Number,
      isLoggedIn: Boolean,
      me: Object
    },

    data() {
      return {
        apiBaseUrl: window.appVariables.api_base_url,
        accountDetails: null,
        facebookDelegate: false,
        googleDelegate: false,
      };
    },

    computed: {
      hasAccountId() {
        return !!this.me.customer_id;
      }
    },

    mounted() {
      if (window._PR?.error) {
        alert(
          'Could not connect social media account, because it is already linked to another account.  Try logging into another account in Facebook or Google on your device and try linking it again. Thank you'
        );
      }
      if(this.isLoggedIn) {
        this.accountDetails = this.me;
      }
    },

    watch: {
      isLoggedIn(loggedIn) {
        if (loggedIn) {
          this.accountDetails = this.me;

          for (const delegate of this.accountDetails.delegate_ids) {
            if (delegate.type === 'facebook') {
              this.facebookDelegate = true;
            }
            if (delegate.type === 'google') {
              this.googleDelegate = true;
            }
          }
        }
      },
    },

    methods: {
      fileChange(e) {
        const dataTarget = e.dataTransfer || e.target;
        const file = dataTarget.files[0];
        const formData = new FormData();

        formData.append('file', file);

        axios({ url: `/api/proxify/me/upload`, method: 'POST', data: formData })
          .then((response) => {
            if (response.data.image_url) {
              this.accountDetails.profile_image_url = `${response.data.image_url}?cache=false`;
            }
          })
          .catch((response) => console.log(response));
      },

      connectSocialAccount(provider) {
        axios
          .get('/api/proxify/me/delegateLink')
          .then(({ data, status }) => {
            if (status === 200) {
              // pass the token to social delegate endpoint to finally connect the account by creating a browser post request
              // todo find a better way to pass client id rather than passing the constant
              const url = `${window.appVariables.app_url}/my-account`;
              const redirectURLString = encodeURIComponent(url);
              const redirectURL = `${window.appVariables.sso_base_url}/oauth2/delegate-authorize?response_type=code&client_id=2000&redirect_uri=${redirectURLString}&delegate=${provider}&tid=${data.message}`;
              window.location.href = redirectURL;
            } else {
              throw new Error('Unable to connect social media account');
            }
          })
          .catch((response) => {
            console.log(response);
          });
      },

      disconnectSocialAccount(provider) {
        let providerId = '';
        for (const delegate of this.accountDetails.delegate_ids) {
          if (delegate.type === provider) {
            providerId = delegate.user_id;
          }
        }
        let projectData = {
          type: provider,
          user_id: providerId,
        };

        axios({
          url: `/api/proxify/me/delegateUnlink`,
          method: 'POST',
          data: projectData,
        })
          .then(({ data, status }) => {
            if (status === 200) {
              window.location.href = '/my-account';
            } else {
              throw new Error('Unable to disconnect social media account');
            }
          })
          .catch((response) => {
            console.log(response);
          });
      },

      showSignupCountryModal() {
        const userProfileData = this.me;
        const noCustomerId =
          userProfileData !== null && userProfileData.customer_id === null;

        if (noCustomerId) {
          $('#signupCountryModal').modal('show');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .photo-in {
    position: relative;
  }
  .wrap-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    z-index: 1;
    transition: all 0.3s ease;
    cursor: pointer;
  }
  .photo-profile .yellow-check {
    z-index: 2;
  }
  .wrap-file input[type='file'] {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .wrap-file i {
    opacity: 0;
    transition: all 0.3s ease;
    position: absolute;
    font-size: 1.8rem;
    top: calc(50% - 9px);
    left: calc(50% - 9px);
    z-index: 1;
  }
  .wrap-file:hover {
    background: rgba(0, 0, 0, 0.5);
  }
  .wrap-file:hover i {
    opacity: 1;
    color: #eee;
  }
  .photo-profile .photo-in img {
    margin-top: 0;
  }

  .fb-btn-group{
    margin-bottom: 10px;
  }
</style>
